import React, { useEffect, useState } from 'react';
import { useCarousel } from '../common/landingHooks';
import { VIDEOS } from './resourcesData';

const ChevronL = () => <svg viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6" /></svg>;
const ChevronR = () => <svg viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6" /></svg>;
const PlayIcon = () => <svg viewBox="0 0 24 24" fill="white"><polygon points="5 3 19 12 5 21 5 3" /></svg>;
const CloseIcon = () => <svg viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg>;

const ResourcesVideoSection = () => {
    const { viewportRef, trackRef, next, prev, pause, resume } = useCarousel(VIDEOS.length, { autoplayMs: 0 });
    const [openId, setOpenId] = useState(null);

    useEffect(() => {
        if (!openId) return;
        const onKey = (e) => { if (e.key === 'Escape') setOpenId(null); };
        window.addEventListener('keydown', onKey);
        return () => window.removeEventListener('keydown', onKey);
    }, [openId]);

    return (
        <section className="lp-res-videos">
            <div className="lp-res-videos-head">
                <span className="eyebrow">Short films</span>
                <h2>Diligentsia in under 3 minutes.</h2>
            </div>
            <div className="lp-res-videos-arrows">
                <button aria-label="Previous" onClick={prev}><ChevronL /></button>
                <button aria-label="Next" onClick={next}><ChevronR /></button>
            </div>

            <div className="lp-viewport" onMouseEnter={pause} onMouseLeave={resume}>
                <div className="lp-vp-inner" ref={viewportRef}>
                    <div className="lp-track" ref={trackRef}>
                        {VIDEOS.map((v) => (
                            <div className="lp-res-vidcard" key={v.id} onClick={() => setOpenId(v.id)}>
                                <div className="thumb" style={{ background: v.gradient }}>
                                    <div className="play" style={{ background: v.playBg }}><PlayIcon /></div>
                                </div>
                                <div className="meta">
                                    <span className="tag" style={{ background: v.tagBg, color: v.tagColor }}>{v.tag}</span>
                                    <div className="title">{v.title}</div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {openId && (
                <div className="lp-res-vidmodal">
                    <div className="scrim" onClick={() => setOpenId(null)} />
                    <div className="panel">
                        <button className="close" aria-label="Close" onClick={() => setOpenId(null)}><CloseIcon /></button>
                        <div className="frame">
                            <iframe
                                title="Diligentsia video"
                                src={`https://player.vimeo.com/video/${openId}?autoplay=1&title=0&byline=0&portrait=0`}
                                frameBorder="0"
                                allow="autoplay; fullscreen; picture-in-picture"
                                allowFullScreen
                            />
                        </div>
                    </div>
                </div>
            )}
        </section>
    );
};

export default ResourcesVideoSection;
